import { Col, Row } from "reactstrap";
import { dynamicImage, Image } from "../../../Utils";
import PageImage from "../../CommonComponents/PageImage";
import Counters from "./Counters";
import MessagesSecure from "./MessagesSecure";
import Slider from "./Slider";

const AboutContainer = () => {
  return (
    <div>
      <PageImage />
      <section className="about-page section-py-space">
        <div className="custom-container">
          <Row>
            <Col sm="12" className="text-center">
              <div className="about-details">
                <Image className="img-fluid w-100 rounded" src={dynamicImage("about/2.jpg")} alt="about" />
                <Row>
                  <Col md="10" className="offset-md-1">
                    <p className="pt-4">{"On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire, that they cannot foresee the pain and trouble that are bound to ensue; and equal blame belongs to those who fail in their duty through weakness of will, which is the same as saying through shrinking from toil and pain. These cases are perfectly simple and easy to distinguish."}</p>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </section>
      <Slider />
      <MessagesSecure />
      <Counters />
    </div>
  );
};

export default AboutContainer;
